
import { Component, Directive, ContentChildren, QueryList, AfterContentInit } from '@angular/core';

@Directive({ selector: 'pui-dialog-title' })
export class PuiDialogTitleDirective { }

@Directive({ selector: 'pui-dialog-content' })
export class PuiDialogContentDirective { }

@Directive({ selector: 'pui-dialog-actions' })
export class PuiDialogActionsDirective { }

@Component({
    selector: 'pui-dialog',
    templateUrl: 'dialog.component.html',
    styleUrls: ['./dialog.component.scss' ]
})

export class PuiDialogComponent implements AfterContentInit {
    @ContentChildren(PuiDialogTitleDirective) dialogTitle: QueryList<PuiDialogTitleDirective>;
    @ContentChildren(PuiDialogContentDirective) dialogContent: QueryList<PuiDialogContentDirective>;
    @ContentChildren(PuiDialogActionsDirective) dialogActions: QueryList<PuiDialogActionsDirective>;

    constructor() { }

    ngAfterContentInit() {
        if (this.dialogTitle.length > 1) {
            throw new Error('Duplicate pui-dialog-title component at in pui-dialog.');
        }
        if (this.dialogContent.length > 1) {
            throw new Error('Duplicate pui-dialog-content component at in pui-dialog.');
        }
        if (this.dialogActions.length > 1) {
            throw new Error('Duplicate pui-dialog-actions component at in pui-dialog.');
        }
    }
}
